export default "__VITE_ASSET__BGWmtS8o__"